export default "__VITE_ASSET__bltiJono__"